import React from "react";
import AuthenticityTokenField from "../forms/AuthenticityTokenField";
import {
  JOB_STATUS_LABELS,
  jobSiteStatusActions,
  type JobStatus,
} from "@toolkit/mobile-shared";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import type { JobDetail } from "../../pages/MainAppPage/types";

type JobSiteStatusCardProps = {
  job: JobDetail;
  jobPath: string;
  csrfToken: string;
};

export const JobSiteStatusCard: React.FC<JobSiteStatusCardProps> = ({
  job,
  jobPath,
  csrfToken,
}) => {
  const status = (job.status ?? "active") as JobStatus;
  const actions = jobSiteStatusActions(status);

  return (
    <Card className="bg-card">
      <CardHeader>
        <CardTitle className="text-base">Site status</CardTitle>
        <CardDescription>
          Current status: {JOB_STATUS_LABELS[status]}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        {actions.map((action) => (
          <form key={action.nextStatus} action={jobPath} method="post">
            <AuthenticityTokenField csrfToken={csrfToken} />
            <input type="hidden" name="_method" value="patch" />
            <input type="hidden" name="job[status]" value={action.nextStatus} />
            <Button
              type="submit"
              variant={action.destructive ? "outline" : "secondary"}
              className={
                action.destructive
                  ? "border-destructive/40 text-destructive hover:bg-destructive/10"
                  : undefined
              }
            >
              {action.label}
            </Button>
          </form>
        ))}
      </CardContent>
    </Card>
  );
};
